function generateData() {
  var data = [];
  for (var i = 0; i < 200; i++) {
    var x = Math.random() * 100000;
    var y = (Math.random() - 0.5) * 200 * (1 - x / 100000);
    data.push([x, y]);
  }
  return data;
}

const data = generateData();

export const colorPalette = {
  primary: {
    darkgreen: '#007A33',
    orange: '#D50000',
    green: '#009E73',
    grey: '#999999',
    olive: '#8C8C00',
    blue: '#0072B2',
    lightgreen: '#66C2A5',
    purple: '#CC79A7',
  },
};

export const mockData = {
  file: { name: 'Output-Report.xlsx', href: '/download/Output-Report.xlsx' },
  charts: [
    {
      title: {
        text: 'Emission quantile regression',
      },
      xAxis: {
        name: 'Bridger measured emission (SCFH)',
        type: 'value',
      },
      yAxis: {
        name: 'Estimation error (%)',
        type: 'value',
      },
      series: [
        {
          name: 'Scatter',
          type: 'scatter',
          data: data,
          markLine: {
            silent: true,
            lineStyle: {
              type: 'solid',
              color: 'black',
            },
            data: [{ type: 'average', name: 'Average' }],
            transform: {
              type: 'ecStat:regression',
              config: {
                method: 'exponential',
              },
            },
          },
        },
      ],
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'secondary',
    },

    {
      xAxis: {
        type: 'category',

        name: 'Estimation Error (%)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          data: [4, 7, 9, 13, 17, 10, 9, 6, 7, 3, 2, 4, 2, 2, 1, 0, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
        },
      ],
      title: {
        text: 'Distribution of the first plume at first path',
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'secondary',
    },

    {
      xAxis: {
        type: 'category',

        name: 'Estimation Error (%)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['Path 1'],
        top: 30,
        left: 'left',
      },
      grid: {
        top: 80,
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Path 1',
          data: [4, 7, 9, 13, 17, 10, 9, 6, 7, 3, 2, 4, 2, 2, 1, 0, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
        },
      ],
      title: {
        text: 'Distribution of the first plume of all four paths',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts',
    },

    {
      xAxis: {
        type: 'category',

        name: 'Estimation Error (%)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['Path 2'],
        top: 30,
        left: 'left',
      },
      grid: {
        top: 80,
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Path 2',
          data: [4, 1, 9, 16, 17, 10, 9, 3, 7, 3, 2, 0, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
        },
      ],
      title: {
        text: 'Distribution of the first plume of all four paths',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts',
    },
    {
      xAxis: {
        type: 'category',

        name: 'Estimation Error (%)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['Path 3'],
        top: 30,
        left: 'left',
      },
      grid: {
        top: 80,
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Path 3',
          data: [1, 7, 8, 11, 10, 8, 9, 6, 5, 3, 2, 1, 2, 0, 1, 0, 1, 0, 1, 2],
          type: 'bar',
          barCategoryGap: '0%',
        },
      ],
      title: {
        text: 'Distribution of the first plume of all four paths',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts',
    },
    {
      xAxis: {
        type: 'category',

        name: 'Estimation Error (%)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['Path 4'],
        top: 30,
        left: 'left',
      },
      grid: {
        top: 80,
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Path 4',
          data: [3, 6, 8, 14, 16, 11, 8, 6, 7, 3, 1, 3, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
        },
      ],
      title: {
        text: 'Distribution of the first plume of all four paths',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts clear',
    },

    {
      xAxis: [
        {
          type: 'value',
        },
      ],
      yAxis: [
        {
          type: 'value',
        },
      ],
      series: [
        {
          name: 'Direct',
          type: 'bar',
          barCategoryGap: '0%',
          barWidth: '100%',
          itemStyle: { color: colorPalette.primary.blue },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 45,
                label: {
                  formatter: 'Median: {c} SCFH',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
          data: [
            [5, 20],
            [15, 52],
            [25, 200],
            [35, 334],
            [45, 390],
            [55, 330],
            [65, 220],
          ],
        },
      ],
      title: {
        text: 'Distribution of the first plume at first path',
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'secondary',
    },

    {
      xAxis: {
        type: 'category',
        name: 'Emission intensity (kg CH4/kg CH4 production)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['Path 1'],
        top: 30, // the size of title + margin
        left: 'left',
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Path 1',
          data: [4, 7, 9, 13, 17, 10, 9, 6, 7, 3, 2, 4, 2, 2, 1, 0, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
          itemStyle: { color: colorPalette.primary.blue },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 10,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
              {
                name: 'Bridger as-measured',
                xAxis: 11,
                label: {
                  formatter: 'Bridger as-measured: {c}',
                  position: 'end',
                  distance: 50,
                },
                lineStyle: {
                  color: 'black',
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Distribution of the first plume of all four paths',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts',
    },
    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (kg CH4/kg CH4 production)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['Path 2'],
        top: 30, // the size of title + margin
        left: 'left',
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Path 2',
          data: [4, 1, 9, 16, 17, 10, 9, 3, 7, 3, 2, 0, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          itemStyle: { color: colorPalette.primary.blue },
          barCategoryGap: '0%',
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 9,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
              {
                name: 'Bridger as-measured',
                xAxis: 11,
                label: {
                  formatter: 'Bridger as-measured: {c}',
                  position: 'end',
                  distance: 50,
                },
                lineStyle: {
                  color: 'black',
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Distribution of the first plume of all four paths',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts',
    },
    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (kg CH4/kg CH4 production)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['Path 3'],
        top: 30, // the size of title + margin
        left: 'left',
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Path 3',
          data: [1, 7, 8, 11, 10, 8, 9, 6, 5, 3, 2, 1, 2, 0, 1, 0, 1, 0, 1, 2],
          type: 'bar',
          itemStyle: { color: colorPalette.primary.blue },
          barCategoryGap: '0%',
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 7,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
              {
                name: 'Bridger as-measured',
                xAxis: 11,
                label: {
                  formatter: 'Bridger as-measured: {c}',
                  position: 'end',
                  distance: 50,
                },
                lineStyle: {
                  color: 'black',
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Distribution of the first plume of all four paths',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts',
    },
    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (kg CH4/kg CH4 production)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['Path 4'],
        top: 30, // the size of title + margin
        left: 'left',
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Path 4',
          data: [3, 6, 8, 14, 16, 11, 8, 6, 7, 3, 1, 3, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
          itemStyle: { color: colorPalette.primary.blue },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 6,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
              {
                name: 'Bridger as-measured',
                xAxis: 11,
                label: {
                  formatter: 'Bridger as-measured: {c}',
                  position: 'end',
                  distance: 50,
                },
                lineStyle: {
                  color: 'black',
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Distribution of the first plume of all four paths',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts clear',
    },

    {
      xAxis: {
        type: 'category',

        name: 'Emission Rate (SCFH)',
        nameLocation: 'middle',
        nameGap: 50,
        data: [1],
      },
      yAxis: {
        type: 'value',
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 40,
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      series: [
        {
          name: 'CCL baseline',
          type: 'bar',
          barCategoryGap: '0%',
          barWidth: '100%',
          itemStyle: { color: colorPalette.primary.purple },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 45,
                label: {
                  formatter: 'Median: {c} SCFH',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
          data: [],
        },
      ],
      title: {
        text: 'Site Level Distribution',
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'primary',
      id: 'primary-1',
    },
    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (kg CH4/kg CH4 production)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Path 1',
          data: [3, 6, 8, 14, 16, 11, 8, 6, 7, 3, 1, 3, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
          itemStyle: { color: colorPalette.primary.purple },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 6,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
              {
                name: 'Bridger as-measured',
                xAxis: 11,
                label: {
                  formatter: 'Bridger as-measured: {c}',
                  position: 'end',
                  distance: 50,
                },
                lineStyle: {
                  color: 'black',
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Distribution of the first emission source in CCL at baseline',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'secondary',
    },

    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (x10^-5)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['Source 1'],
        top: 30, // the size of title + margin
        left: 'left',
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Source 1',
          data: [3, 6, 8, 14, 16, 11, 8, 6, 7, 3, 1, 3, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
          itemStyle: { color: colorPalette.primary.purple },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 6,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Distribution of the first four emission source in CCL at baseline',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts',
    },
    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (x10^-5)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['Source 2'],
        top: 30, // the size of title + margin
        left: 'left',
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Source 2',
          data: [3, 6, 8, 14, 16, 11, 8, 6, 7, 3, 1, 3, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
          itemStyle: { color: colorPalette.primary.purple },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 6,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Distribution of the first four emission source in CCL at baseline',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts',
    },
    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (x10^-5)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['Source 3'],
        top: 30, // the size of title + margin
        left: 'left',
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Source 3',
          data: [3, 6, 8, 14, 16, 11, 8, 6, 7, 3, 1, 3, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
          itemStyle: { color: colorPalette.primary.purple },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 6,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Distribution of the first four emission source in CCL at baseline',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts',
    },
    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (x10^-5)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['Source 4'],
        top: 30, // the size of title + margin
        left: 'left',
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Source 4',
          data: [3, 6, 8, 14, 16, 11, 8, 6, 7, 3, 1, 3, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
          itemStyle: { color: colorPalette.primary.purple },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 6,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Distribution of the first four emission source in CCL at baseline',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts clear',
    },

    {
      xAxis: {
        type: 'category',

        name: 'Emission Rate (SCFH)',
        nameLocation: 'middle',
        nameGap: 50,
        data: [1],
      },

      yAxis: {
        type: 'value',
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 40,
      },

      series: [
        {
          name: 'Frequency',
          type: 'bar',
          barCategoryGap: '0%',
          barWidth: '100%',
          itemStyle: { color: colorPalette.primary.lightgreen },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 45,
                label: {
                  formatter: '{c} SCFH',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
          data: [],
        },
      ],
      title: {
        text: 'Emission Intensity Distribution',
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'primary',
      id: 'primary-2',
    },
    {
      xAxis: {
        type: 'category',
        name: 'Emission intensity (kg CH4/kg CH4 production)',
        nameLocation: 'middle',
        nameGap: 50,
        data: [1],
      },

      yAxis: {
        type: 'value',
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 40,
      },

      series: [
        {
          name: 'Frequency',
          type: 'bar',
          barCategoryGap: '0%',
          barWidth: '100%',
          itemStyle: { color: colorPalette.primary.green },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 45,
                label: {
                  formatter: '{c} SCFH',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
          data: [],
        },
      ],
      title: {
        text: 'Emission Rate Distribution',
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'primary',
      id: 'primary-3',
    },

    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (kg CH4/kg CH4 production)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Source 1',
          data: [3, 6, 8, 14, 16, 11, 8, 6, 7, 3, 1, 3, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
          itemStyle: { color: colorPalette.primary.lightgreen },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 6,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Site level emission distribution for site 1 across baseline, EMs and EOP',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts',
    },
    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (kg CH4/kg CH4 production)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['CCL EM-1 1566873 kg/hr'],
        top: 30, // the size of title + margin
        left: 'left',
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Source 1',
          data: [3, 6, 8, 14, 16, 11, 8, 6, 7, 3, 1, 3, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          itemStyle: { color: colorPalette.primary.lightgreen },
          barCategoryGap: '0%',
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 6,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Site level emission distribution for site 1 across baseline, EMs and EOP',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts',
    },
    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (kg CH4/kg CH4 production)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['CCL EM-2 1566873 kg/hr'],
        top: 30, // the size of title + margin
        left: 'left',
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Source 1',
          data: [3, 6, 8, 14, 16, 11, 8, 6, 7, 3, 1, 3, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
          itemStyle: { color: colorPalette.primary.lightgreen },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 6,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Site level emission distribution for site 1 across baseline, EMs and EOP',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts',
    },
    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (kg CH4/kg CH4 production)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['CCL EM-3 1566873 kg/hr'],
        top: 30, // the size of title + margin
        left: 'left',
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Source 1',
          data: [3, 6, 8, 14, 16, 11, 8, 6, 7, 3, 1, 3, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
          itemStyle: { color: colorPalette.primary.lightgreen },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 6,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Site level emission distribution for site 1 across baseline, EMs and EOP',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts',
    },
    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (kg CH4/kg CH4 production)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['CCL EM-4 1566873 kg/hr'],
        top: 30, // the size of title + margin
        left: 'left',
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Source 1',
          data: [3, 6, 8, 14, 16, 11, 8, 6, 7, 3, 1, 3, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
          itemStyle: { color: colorPalette.primary.lightgreen },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 6,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Site level emission distribution for site 1 across baseline, EMs and EOP',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts',
    },
    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (kg CH4/kg CH4 production)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['CCL EM-5 1566873 kg/hr'],
        top: 30, // the size of title + margin
        left: 'left',
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Source 1',
          data: [3, 6, 8, 14, 16, 11, 8, 6, 7, 3, 1, 3, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
          itemStyle: { color: colorPalette.primary.lightgreen },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 6,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Site level emission distribution for site 1 across baseline, EMs and EOP',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts',
    },
    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (kg CH4/kg CH4 production)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['CCL EOP 1556873 kg/hr'],
        top: 30, // the size of title + margin
        left: 'left',
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Source 1',
          data: [3, 6, 8, 14, 16, 11, 8, 6, 7, 3, 1, 3, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
          itemStyle: { color: colorPalette.primary.lightgreen },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 6,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Site level emission distribution for site 1 across baseline, EMs and EOP',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts clear',
    },

    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (kg CH4/kg CH4 production)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['SPL baseline 1556873 kg/hr'],
        top: 30, // the size of title + margin
        left: 'left',
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Source 1',
          data: [3, 6, 8, 14, 16, 11, 8, 6, 7, 3, 1, 3, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
          itemStyle: { color: colorPalette.primary.lightgreen },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 6,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Site level emission distribution for site 2 across baseline, EMs and EOP',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts',
    },
    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (kg CH4/kg CH4 production)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['SPL EM-1 1556873 kg/hr'],
        top: 30, // the size of title + margin
        left: 'left',
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Source 1',
          data: [3, 6, 8, 14, 16, 11, 8, 6, 7, 3, 1, 3, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
          itemStyle: { color: colorPalette.primary.lightgreen },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 6,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Site level emission distribution for site 2 across baseline, EMs and EOP',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts',
    },
    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (kg CH4/kg CH4 production)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['SPL EM-2 1556873 kg/hr'],
        top: 30, // the size of title + margin
        left: 'left',
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Source 1',
          data: [3, 6, 8, 14, 16, 11, 8, 6, 7, 3, 1, 3, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
          itemStyle: { color: colorPalette.primary.lightgreen },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 6,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Site level emission distribution for site 2 across baseline, EMs and EOP',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts',
    },
    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (kg CH4/kg CH4 production)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['SPL EM-3 1556873 kg/hr'],
        top: 30, // the size of title + margin
        left: 'left',
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Source 1',
          data: [3, 6, 8, 14, 16, 11, 8, 6, 7, 3, 1, 3, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
          itemStyle: { color: colorPalette.primary.lightgreen },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 6,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Site level emission distribution for site 2 across baseline, EMs and EOP',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts',
    },
    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (kg CH4/kg CH4 production)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['SPL EM-4 1556873 kg/hr'],
        top: 30, // the size of title + margin
        left: 'left',
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Source 1',
          data: [3, 6, 8, 14, 16, 11, 8, 6, 7, 3, 1, 3, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
          itemStyle: { color: colorPalette.primary.lightgreen },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 6,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Site level emission distribution for site 2 across baseline, EMs and EOP',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts',
    },
    {
      xAxis: {
        type: 'category',

        name: 'Emission intensity (kg CH4/kg CH4 production)',
        nameLocation: 'middle',
        nameGap: 50,
      },
      legend: {
        data: ['SPL EOP 1556873 kg/hr'],
        top: 30, // the size of title + margin
        left: 'left',
      },
      grid: {
        top: 80, // the size of title + legend + margin
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}',
        },
        name: 'Frequency',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        max: 20,
      },
      series: [
        {
          name: 'Source 1',
          data: [3, 6, 8, 14, 16, 11, 8, 6, 7, 3, 1, 3, 2, 2, 1, 4, 1, 0, 1, 1],
          type: 'bar',
          barCategoryGap: '0%',
          itemStyle: { color: colorPalette.primary.lightgreen },
          markLine: {
            data: [
              {
                name: 'Median',
                xAxis: 6,
                label: {
                  formatter: 'Median: {c}',
                  position: 'middle',
                },
                lineStyle: {
                  color: colorPalette.primary.orange,
                  type: 'dashed',
                  width: 2,
                },
              },
            ],
          },
        },
      ],
      title: {
        text: 'Site level emission distribution for site 2 across baseline, EMs and EOP',
        textStyle: {
          fontSize: '12px',
        },
      },
      animation: false,
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      chart_type: 'quad-charts clear',
    },
  ],
};
